import React, { useState } from 'react';
import { useRef, useEffect } from "react";
import { ArrowUpRight } from "react-feather"; // Using react-feather for the arrow icon
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import './About.css'
import missionImg from "../images/rocket-icon.png";
import visionImg from "../images/blub-icon.png"
import valuesImg from "../images/360-icon.png";
// Events
// Import images (use your own image paths)
import img1993 from "../images/events/event-1.jpg";
import img1998 from "../images/events/event-2.jpg";
import img2021a from "../images/events/IMG_2540 (1) (1).png";
import img2021b from "../images/events/event-4.png"




function AboutUs() {

  // Prodcuts Series Starts

  const swiper1Ref = useRef(null);
  const swiper2Ref = useRef(null);

  // Function to attach hover events
  const attachHoverEvents = (swiperRef) => {
    if (swiperRef.current && swiperRef.current.el) {
      swiperRef.current.el.addEventListener("mouseenter", () => swiperRef.current.autoplay.stop());
      swiperRef.current.el.addEventListener("mouseleave", () => swiperRef.current.autoplay.start());
    }
  };

  // Attach event listeners when Swiper initializes
  useEffect(() => {
    if (swiper1Ref.current) attachHoverEvents(swiper1Ref);
    if (swiper2Ref.current) attachHoverEvents(swiper2Ref);
  }, []);

  useEffect(() => {
    if (swiper1Ref.current && swiper1Ref.current.swiper) {
      swiper1Ref.current.swiper.params.navigation.prevEl = ".prev1";
      swiper1Ref.current.swiper.params.navigation.nextEl = ".next1";
      swiper1Ref.current.swiper.navigation.init();
      swiper1Ref.current.swiper.navigation.update();
    }

    if (swiper2Ref.current && swiper2Ref.current.swiper) {
      swiper2Ref.current.swiper.params.navigation.prevEl = ".prev2";
      swiper2Ref.current.swiper.params.navigation.nextEl = ".next2";
      swiper2Ref.current.swiper.navigation.init();
      swiper2Ref.current.swiper.navigation.update();
    }
  }, []);

  // Writing Items
  const writingItems = [
    {
      id: 9,
      image: require("../images/latest-writing/news-9.jpg"),
      name: "PV60",
      date: "29 July 2023",
      description: `
<p>PREMIER is the largest exporter of Liquid Ring Vaccuum Pumps and Spares with installations in more than forty countries.</p>
`
    },




    {
      id: 3,
      image: require("../images/latest-writing/news-3.jpg"),
      name: "PV60",
      date: "16 November 2024",
      description: `
<p>PREMIER make P501 M pump equivalent to NASH 904 M arrives in a paper mill in the U.S.A</p>
<p>Contact PREMIER for your emergency requirements to replace your existing O.E.M Vacuum Pumps and spares.</p>
`
    },

    {
      id: 2,
      image: require("../images/latest-writing/news-7.jpeg"),
      name: "PV60",
      date: "09 January 2025",
      description: `
<p>PREMIER offers its unique performance evaluation services for Liquid Ring Vacuum Pumps with minimum pump shutdown time, giving in time failure predictions and minimizing plant shutdown costs due to pump failure.</p>
`
    },


  ];
  // Writing Items


  return (
    <div>
      {/* Hero Section  */}
      <section className="about">
        {/*  */}
        <section class="container-fluid about-hero py-5">
          <div class="container py-md-5 py-0">
            <div class="row justify-content-center align-items-center py-md-5 py-0">
              <div class="col-lg-3">
                <h1 class="fs-1 text-blue">OUR STORY</h1>
              </div>
              <div class="col-lg-7">
                {/* <h3 class="card-title fw-bold text-blue">Mr. T. Venkat</h3>
                <h6 class="card-subtitle mb-3 text-blue">Director</h6> */}
                <p className="card-text fs-5">
                  Premier has been manufacturing liquid ring vacuum pumps since 2011, delivering consistent quality and performance. Our pumps are engineered to meet the demands of diverse industrial applications.
                </p>
                <p className="card-text fs-5">
                  With a global distribution network, we serve clients across multiple countries with reliability and efficiency.
                </p>
                {/* <p class="fs-5"><span className="text-blue">Since 1991,</span> PREMIER has been a leading manufacturer of Water Ring Vacuum Pumps, with 25 specialized models offering capacities up to 30,000 m³/h. We provide custom vacuum systems and stock pumps for industries like Thermal Power Plants, Pulp & Paper Mills, and other process applications, delivering tailored solutions worldwide.</p> */}
              </div>
            </div>
          </div>
        </section>

        {/*Membership Cards */}

        {/*Membership Cards */}

        {/* <div className="life-journey">
          <div className="container">
            <h2 className="text-center text-blue fw-bold mb-4">Our Journey</h2>
            <p className="text-center">With 30+ years of expertise, we supply high-performance Liquid Ring Vacuum Pumps to global markets. Our advanced manufacturing facility, skilled workforce, and expert engineering team ensure reliable, superior-quality products for every industrial need.</p>
          </div>

          <div className="line-wrapper container position-relative py-4">

            <div className="timeline-vertical-line wow " data-wow-duration="5s"></div>
            <div className="row justify-content-center">
              <div className="col-lg-10 my-3 wow animate__fadeInUp" data-wow-duration="1.5s">
                <div className="row justify-content-cente">
                  <div className="col-5">
                    <img src={img1993} alt="1993" className="img-fluid rounded-3" />
                  </div>
                  <div className="col-2 d-flex align-items-center justify-content-center">
                    <div className="text-center bg-white p-2">
                      <div className="d-flex justify-content-center mb-2">
                        <div className="time-dot blinking"></div>
                      </div>
                      <div className="text-blue">
                        <span className="fs-4 fw-bold fs-sm-10">1991</span>
                        <p className="fs-6 fw-bold fs-sm-10">INCEPTION</p>

                      </div>
                    </div>
                  </div>
                  <div className="col-5 d-flex align-items-center">
                    <p className="fs-sm-10">Began manufacturing of centrifugal process pumps to serve Hyderabad's budding pharmaceutical industry, rapidly positioning ourselves as the market leader.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-10 my-3 wow animate__fadeInUp" data-wow-duration="1.5s">
                <div className="row justify-content-cente">
                  <div className="col-5 d-flex align-items-center">
                    <p className="fs-sm-10">PREMIER began manufacturing it’s flagship product, the Liquid Ring Vacuum Pump, recognizing the growing demand for these pumps in India.
                    </p>
                  </div>
                  <div className="col-2 d-flex align-items-center justify-content-center">
                    <div className="text-center bg-white p-2">
                      <div className="d-flex justify-content-center mb-2">
                        <div className="time-dot blinking"></div>
                      </div>
                      <div className="text-blue">
                        <span className="fs-4 fw-bold fs-sm-10">1994</span>
                        <p className="fs-6 fw-bold fs-sm-10">PRODUCT DIVERSIFICATION
                        </p>

                      </div>
                    </div>
                  </div>
                  <div className="col-5">
                    <img src={img1998} alt="1998" className="img-fluid rounded-3" />
                  </div>
                </div>
              </div>
              <div className="col-lg-10 my-3 wow animate__fadeInUp" data-wow-duration="1.5s">
                <div className="row justify-content-cente">
                  <div className="col-5">
                    <img src={img2021a} alt="2021" className="img-fluid rounded-3" />
                  </div>
                  <div className="col-2 d-flex align-items-center justify-content-center">
                    <div className="text-center bg-white p-2">
                      <div className="d-flex justify-content-center mb-2">
                        <div className="time-dot blinking"></div>
                      </div>
                      <div className="text-blue">
                        <span className="fs-4 fw-bold fs-sm-10">2011</span>
                        <p className="fs-6 fw-bold fs-sm-10">GOING GLOBAL
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-5 d-flex align-items-center justify-content-center">
                    <p className="fs-sm-10">In pursuit of supplying Liquid Ring Vacuum Pumps in the North and South American regions, PREMIER commenced operations in the U.S.A

                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-10 my-3 wow animate__fadeInUp" data-wow-duration="1.5s">
                <div className="row justify-content-cente">
                  <div className="col-5 d-flex align-items-center justify-content-center">
                    <p className="fs-sm-10">PREMIER intends to revolutionize the Liquid Ring Vacuum Pump market with energy efficient and smart pumps that address the modern challenges of process industries.</p>
                  </div>
                  <div className="col-2 d-flex align-items-center justify-content-center">
                    <div className="text-center bg-white p-2">
                      <div className="d-flex justify-content-center mb-2">
                        <div className="time-dot blinking"></div>
                      </div>
                      <div className="text-blue">
                        <p className="fs-6 fw-bold fs-sm-10">TODAY AND BEYOND
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-5">
                    <img src={img2021b} alt="2021" className="img-fluid rounded-3" />
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div> */}

        <section class="container-fluid py-5 mb-5">
          <div class="container">
            {/* <h2 className="text-center fw-bold text-blue mb-5">Our Purpose</h2> */}
            <div class="row justify-content-center gap-2 py-5">


              <div class="col-lg-3 ">
                <div class="about-card d-flex align-items-center justify-content-between flex-column gap-4 h-100 px-3">
                  <div class="card-border col-10"></div>
                  <img class="w-px-60  " src={visionImg} alt="" />
                  <div className="p-3 text-center">
                    <h5 class="fw-bold mb-3">
                      Vision Statement
                    </h5>
                    <p class="fs-7">
                      To be the best in what we do.
                    </p>
                  </div>
                  <div class="card-border col-10"></div>
                </div>
              </div>

              <div class="col-lg-3 ">
                <div class="about-card d-flex align-items-center justify-content-between flex-column gap-4 h-100 px-3">
                  <div class="card-border col-10"></div>
                  <img class="w-px-60  " src={missionImg} alt="" />
                  <div className="p-3 text-center">
                    <h5 class="fw-bold mb-3">
                      Mission Statement
                    </h5>
                    <p class="fs-7">
                      Making process industries efficient and profitable by manufacturing pumps that are energy and cost effecient.
                    </p>
                  </div>
                  <div class="card-border col-10"></div>
                </div>
              </div>

              <div class="col-lg-3 ">
                <div class="about-card d-flex align-items-center justify-content-between flex-column gap-4 h-100 px-3">
                  <div class="card-border col-10"></div>
                  <img class="w-px-60  " src={valuesImg} alt="" />
                  <div className="p-3 text-center">
                    <h5 class="mm-3 fw-bold">
                      Core Statement
                    </h5>
                    <p class=" fs-7">
                      Together towards a better tomorrow.
                    </p>
                  </div>
                  <div class="card-border col-10"></div>
                </div>
              </div>


            </div>

          </div>
        </section>

        {/* Latest Writing */}
        <div className="latest-writing-section mb-5">
          <div className="container">
            <h3 className="fw-bold mb-4">Latest Writing</h3>
            <Swiper
              ref={swiper1Ref}
              onSwiper={(swiper) => (swiper1Ref.current = swiper)}
              modules={[Autoplay, Navigation]}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              speed={1000}
              loop={true}
              slidesPerView={4}
              spaceBetween={20}
              navigation={{ nextEl: ".next1", prevEl: ".prev1" }}
              breakpoints={{
                320: { slidesPerView: 1 },
                576: { slidesPerView: 2 },
                768: { slidesPerView: 2 },
                992: { slidesPerView: 3 },
              }}
              onMouseEnter={() => swiper1Ref.current?.autoplay.stop()}
              onMouseLeave={() => swiper1Ref.current?.autoplay.start()}
            >
              {writingItems.map((item) => {
                const plainText = item.description.replace(/<\/?[^>]+(>|$)/g, "");
                const shortText = plainText.length > 80 ? plainText.substring(0, 80) + "..." : plainText;

                return (
                  <SwiperSlide key={item.id} className="h-100">
                    <Link
                      to={`/writing-details/${item.id}`}
                      state={{
                        name: item.name,
                        date: item.date,
                        description: item.description,
                        image: item.image
                      }}
                      className="text-decoration-none h-100 d-block"
                    >
                      <div className="writing-slide-card bg-white shadow-sm h-100">
                        <div className="d-flex flex-column h-100">
                          <img
                            src={item.image}
                            alt={item.name}
                            className="card-img-top mx-auto rounded-3"
                          />
                          <div className="card-body mt-auto p-3 fs-sm-12">
                            {/* <p className="">{item.date}</p> */}
                            <div className="d-flex justify-content-between align-items-center">
                              <p className="mb-0 text-dark small flex-grow-1 me-3">{shortText}</p>
                              <ArrowUpRight size={20} className="text-blue flex-shrink-0" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </SwiperSlide>
                );
              })}
            </Swiper>

            {/* Custom Navigation Buttons */}
            <div className="d-flex justify-content-end mt-4">
              <button className="btn btn-outline-primary me-2 prev1 px-4 py-0 fs-5">&#8249;</button>
              <button className="btn btn-outline-primary next1  px-4 py-0 fs-5">&#8250;</button>
            </div>
            <div className='text-center d-flex justify-content-center'>
              <Link to="/news" className="text-decoration-none">
                <Button
                  variant="outline-primary text-dark rounded"
                  className="d-flex align-items-center py-2 px-4 fs-5 rounded my-md-0 my-2"
                >
                  View All <ArrowUpRight size={18} className="ms-2" />
                </Button>
              </Link>

            </div>


          </div>
        </div>
        {/* Latest Writing */}

        {/*  */}
      </section>
      {/* Hero Section  */}


    </div>
  )
}

export default AboutUs